import remotesConfig from 'remotesConfig'
import veUtilitiesMfeConfig from 'veUtilitiesMfeConfig'
import injectWindowVariables from '@ve/module-federation/injectWindowVariables'
import injectScripts from '@ve/module-federation/injectScripts'
if (veUtilitiesMfeConfig?.maintenance?.enabled) {
  injectWindowVariables(remotesConfig)
  import('./bootstrap')
} else {
  injectWindowVariables(remotesConfig)
  injectScripts(remotesConfig)
  import('./bootstrap')
}
export {}
